import { APIClient } from '../../helpers/api_helper';
const AxiosClient = new APIClient()

const createTimeline = (payload) => AxiosClient.post('/timeline', payload);
const getTimeline = (params) => AxiosClient.get(`/timeline/${params}`);
const updateTimeline = (payload,params) => AxiosClient.put(`/timeline/${params}`, payload)

export {
    createTimeline,
    getTimeline,
    updateTimeline
}